import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link, StaticQuery, graphql, Slice } from 'gatsby'
import { Footer } from '.'
import { Collapse, Navbar, NavbarToggler, NavbarBrand } from 'reactstrap'
import { globalHistory } from '@reach/router'
import Lazyload from 'react-lazy-load'
import HelloBar from './Hellobar'
import HelloBarFr from './HellobarFr'
import HelloBarEs from './HellobarEs'
import HelloBarDe from './HellobarDe'

import { Trans, useTranslation, useI18next, language } from 'gatsby-plugin-react-i18next'
import { HeaderFrench } from '.'
// import SimpleFooter from '../blog_components/common/SimpleFooter'
// import DownloadButtonSlide from "./SlideDownloadGuide";
// Styles

import '../../styles/mainsite.css'
import '../../styles/custom.css'
import '../../styles/responsive.css'
import { useLocation } from '@reach/router'
import { event } from 'jquery'
import { set } from 'lodash'

/**
 * Main layout component
 *
 * The Layout component wraps around each page and template.
 * It also provides the header, footer as well as the main
 * styles, and meta data for each page.
 *
 */
// Load Poppins typeface
require(`typeface-poppins`)

const DefaultLayout = ({ data, children, bodyclassName, isHome, location }) => {
  const site = data.allGhostSettings.edges[0].node
  const [collapsed, setCollapsed] = useState(true)
  const toggleNavbar = () => setCollapsed(!collapsed)
  const [collapsed1, setCollapsed1] = useState(true)
  const toggleNavbar1 = () => setCollapsed1(!collapsed1)
  // const path = globalHistory.location.pathname;
  const { pathname: path } = useLocation()

  const nonFooterLinks = [`/corporate-wellness-with-vantage-fit/`]

  const { t } = useTranslation()
  const { defaultLanguage, language, originalPath, changeLanguage } = useI18next()

  const defaultLang = language
  const [cssDisplay, setCssDisplay] = useState(`none`)
  const [langSelected, setLangFlag] = useState(defaultLang)
  const [displayHelloBar, setDisplayHelloBar] = useState(true)
  const [scroll1, setScroll1] = useState(false)

  useEffect(() => {
    if (typeof window !== `undefined`) {
      window.addEventListener(`scroll`, () => {
        setScroll1(window.scrollY > 200)
      })
    }
    return () => {
      if (typeof window !== `undefined`) {
        window.removeEventListener(`scroll`, () => {
          setScroll1()
        })
      }
    }
  }, [])

  const languages = [`en-US`, `fr`, `es`, `de`]
  let locationUrl = ``
  if (typeof window !== `undefined`) {
    locationUrl = useLocation().href.indexOf(`/fr/`) > -1
  }
  if (typeof window !== `undefined`) {
    locationUrl = useLocation().href.indexOf(`/es/`) > -1
  }
  if (typeof window !== `undefined`) {
    locationUrl = useLocation().href.indexOf(`/de/`) > -1
  }
  if (locationUrl) {
    let getPreLanguage = localStorage.getItem(`gatsby-i18next-language`)
    if (!getPreLanguage) {
      localStorage.setItem(`gatsby-i18next-language`, language)
    }
  }
  // const [activeTab, setActiveTab] = React.useState("1");

  const showDropdown = () => {
    if (cssDisplay === `none`) {
      setCssDisplay(`block`)
    } else {
      setCssDisplay(`none`)
    }
  }
  const selectLangList = (lang) => {
    // console.log('event',lang);
    setLangFlag(lang)
    changeLanguage(lang)
    setCssDisplay(`none`)
    if (lang == `en-US`) {
      window.location = `/`
    } else {
      window.location = `/` + lang + `/`
    }
    setHellobar(true)
  }

  const setHellobar = (status) => {
    setDisplayHelloBar(status)
  }

  const noHeader = [
    `/vantage-fit-webcast-live/`,
    `/vantage-fit-webcast-live`,
    `/vantage-fit-webcast-registration/`,
    `/vantage-fit-webcast-registration`,
    `/global-corporate-virtual-walkathon/`,
    `/global-corporate-virtual-walkathon`,
    `/global-corporate-virtual-walkathon-v2/`,
    `/global-corporate-virtual-walkathon-v2`,
    `/global-corporate-virtual-walkathon-v3/`,
    `/global-corporate-virtual-walkathon-v3`,
    `/global-corporate-virtual-walkathon-v4/`,
    `/global-corporate-virtual-walkathon-v4`,
    `/contest-guidelines/`,
    `/contest-guidelines`,
    `/leaderboard/`,
    `/leaderboard`,
    `/exclusive-corporate-offer/`,
    `/exclusive-corporate-offer`,

    `/sponsor-registration-global-corporate-virtual-walkathon/`,

    `/sponsor-registration-global-corporate-virtual-walkathon`,
    `/previous-global-corporate-virtual-walkathon`,
    `/previous-global-corporate-virtual-walkathon/`,
    `/global-corporate-virtual-walkathon-2021`,
    `/global-corporate-virtual-walkathon-2021/`,
    `/global-corporate-virtual-walkathon-2022`,
    `/global-corporate-virtual-walkathon-2022/`,

    `/contest-guidelines-global-corporate-virtual-walkathon`,

    `/contest-guidelines-global-corporate-virtual-walkathon/`,

    `/about-us-global-corporate-virtual-walkathon`,

    `/about-us-global-corporate-virtual-walkathon/`,

    `/registration-thank-you-global-corporate-virtual-walkathon`,

    `/registration-thank-you-global-corporate-virtual-walkathon/`,
    `/corporate-wellness-with-vantage-fit/`,
    `/corporate-wellness-with-vantage-fit`,
    `/healthy-new-year`,
    `/healthy-new-year/`,
    `/employee-wellness`,
    `/employee-wellness/`,
    `/employee-wellness-v1`,
    `/employee-wellness-v1/`,
    `/employee-wellness-pmp/`,
    `/fr/planifier-demo/`,
    `/fr/planifier-demo`,
    `/es/solicita-una-demo/`,
    `/es/solicita-una-demo`,
    `/de/demo-anfordern/`,
    `/de/demo-anfordern`,
    `/global-employee-wellness-platform-v1`,
    `/global-employee-wellness-platform-v1/`,
    `/global-employee-wellness-platform-v2/`,
  ]

  const withHeader = [
    `/es/solicita-una-demo/`,
    `/es/solicita-una-demo`,
    `/de/demo-anfordern/`,
    `/de/demo-anfordern`,
    `/fr/`,
    `/fr`,
    // `/fr/wellness-challenges/`,
    // `/fr/wellness-challenges`,
    // `/fr/wellness-programs/`,
    // `/fr/wellness-programs`,
    // `/fr/wellbeing-community/`,
    // `/fr/wellbeing-community`,
    // `/fr/rewards-and-recognition/`,
    // `/fr/rewards-and-recognition`,
  ]

  //   // New showHeader state to control header visibility
  //   const [showHeader, setShowHeader] = useState(null) // Start with null to avoid flickering
  //   // const { pathname: path } = useLocation();
  //   useEffect(() => {
  //     const shouldShowHeader =
  //       !noHeader.includes(path) &&
  //       !path.startsWith('/articles/') &&
  //       !path.startsWith('/vantagefit-wellness-campaigns/') &&
  //       !path.startsWith('/request-demo/')

  //     setShowHeader(shouldShowHeader)
  //   }, [path]) // Depend on `path` to update whenever the URL changes

  //   // If showHeader is null, it means we're still determining the state
  //   if (showHeader === null) {
  //     return null // Return null or a loading spinner while state is being set
  //   }

  const shouldShowHeader =
    !noHeader.includes(path) &&
    !path.startsWith('/articles/') &&
    !path.startsWith('/vantagefit-wellness-campaigns/') &&
    !path.startsWith('/request-demo/')

  return (
    <>
      <div
        className="viewport home-template home page-template page-template-elementor_header_footer page page-id-3550 wp-embed-responsive not_logged_in elementor-default elementor-template-full-width elementor-page elementor-page-3550"
        id="maincont"
      >
        <div className="viewport-top">
          {/* Header logic - Pre-generated at build time */}
          {shouldShowHeader ? (
            withHeader.includes(path) || ['fr', 'es', 'de'].includes(language) ? (
              <HeaderFrench
                site={site}
                langSelected={langSelected}
                toggleNavbar1={toggleNavbar1}
                collapsed1={collapsed1}
                t={t}
                cssDisplay={cssDisplay}
                selectLangList={selectLangList}
                languages={languages}
                showDropdown={showDropdown}
              />
            ) : (
              <div className="headerWrapper">
                {/* { removeHellobarUrl.includes(path) ? null : helloBarMessage === true ? (<Hellobar hellobarTextForUrl={hellobarTextForUrl} />) : null } */}
                <header
                  className={`header_area header_stick nav-black brad48 ${
                    scroll1 ? (displayHelloBar ? `` : ``) : null
                  }`}
                  id="headerarea"
                >
                  {language === 'fr' ? (
                    <HelloBarFr scroll1={scroll1} />
                  ) : language === 'es' ? (
                    <HelloBarEs scroll1={scroll1} />
                  ) : language === 'de' ? (
                    <HelloBarDe scroll1={scroll1} />
                  ) : (
                    <HelloBar scroll1={scroll1} />
                  )}
                  <nav className="navbar navbar-expand-lg menu_center mainsite1">
                    <div className="container custom_container">
                      <div className="site-mast-left">
                        <Link to="/" className="navbar-brand sticky_logo">
                          <img
                            width="220"
                            height="45"
                            className="d_logo site-logo"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                            alt={site.title}
                          />

                          {/* <img
                                                width="220"
                                                height="45"
                                                alt="Vantage Fit"
                                                className="stick_logo"
                                                src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/vantagefit-logo-220-compress-2.png"
                                                data-loaded="true"
                                            /> */}
                          {/* <img
                            width="220"
                            height="45"
                            alt="Vantage Fit Xmas"
                            className="d_logo site-logo"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1734933277/VantageFit/2024/Asset_1.png"
                            data-loaded="true"
                          /> */}
                        </Link>
                      </div>
                      <div className="collapse navbar-collapse justify-content-center vfit-main">
                        <div id="menu-main-menu-global" className="navbar-nav menu  ml-auto">
                          <div className="nav-home menu-item nav-item HeaderN" role="menuitem">
                            <ul className="header_menu">
                              <li className="listingMenu menu-soln solution-menu__item">
                                <a className="site-nav-item " onClick={(e) => e.preventDefault()}>
                                  Solutions
                                </a>
                                <ul className="dropdownmenu row solutions">
                                  <li className="col-4 challenges-menu">
                                    <div className="dropdown-menu-header">Challenges</div>
                                    <a className="site-nav-item" href="/steps-challenge/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          className="mb-2"
                                          src="https://res.cloudinary.com/vantagecircle/image/upload/v1699340014/VantageFit/2023/step_challenge.svg"
                                          alt="Steps Challenges"
                                        />
                                        <div className="ml-4">
                                          <div className="nav-item-heading">
                                            <span className="text-red">Steps</span>
                                            {` `}
                                            Challenge
                                          </div>

                                          <p className="nav-item-desc">
                                            Promote physical activity and engagement through different step tracking
                                            challenges.
                                          </p>
                                        </div>
                                      </div>
                                    </a>
                                    <a className="site-nav-item" href="/multi-activity-challenges/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          className="mb-2"
                                          src="https://res.cloudinary.com/vantagecircle/image/upload/v1699360829/VantageFit/2023/multi_activity_challenge.svg"
                                          alt=" Multi-activity Challenges"
                                        />
                                        <div className="ml-4">
                                          <div className="nav-item-heading">
                                            <span className="text-red">Custom</span>
                                            {` `}
                                            Challenges
                                          </div>
                                          <p className="nav-item-desc">
                                            Create custom challenges to support unique wellness goals and workplace
                                            culture.
                                          </p>
                                        </div>
                                      </div>
                                    </a>
                                    <a className="site-nav-item" href="/team-challenges/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          className="mb-2"
                                          src="https://res.cloudinary.com/vantagecircle/image/upload/v1699340014/VantageFit/2023/team_challenge.svg"
                                          alt="Team ChalleChallengenges"
                                        />
                                        <div className="ml-4">
                                          <div className="nav-item-heading">
                                            <span className="text-red">Team</span>
                                            {` `}
                                            Challenge
                                          </div>
                                          <p className="nav-item-desc mb-0">
                                            Encourage collaboration and healthy competition with team-based wellness
                                            activities.
                                          </p>
                                        </div>
                                      </div>
                                    </a>
                                    <a className="site-nav-item" href="/virtual-marathon/">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src="https://res.cloudinary.com/vantagecircle/image/upload/v1733308256/VantageFit/2024/marathon.png"
                                          alt="Team ChalleChallengenges"
                                        />
                                        <div className="ml-4">
                                          <div className="nav-item-heading">
                                            One Day <span className="text-red">Virtual Marathon</span>
                                          </div>
                                          <p className="nav-item-desc mb-0">
                                            <Trans>
                                              Unite your global workforce through a one-day virtual marathon.
                                            </Trans>
                                          </p>
                                        </div>
                                      </div>
                                    </a>
                                  </li>
                                  <li className="col-8 other-soln-menu">
                                    <div className="dropdown-menu-header">Other solutions</div>
                                    <div className="row">
                                      <div className="col-6 pl-0">
                                        <a className="site-nav-item" href="/remote-team-wellness/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1699340013/VantageFit/2023/remote_team_wellness.svg"
                                            alt="Remote
                                                                                    Team
                                                                                    Wellness"
                                          />
                                          <div className="nav-item-heading">Remote Team Wellness</div>
                                          <p className="nav-item-desc">
                                            Offer wellness solutions that are crafted to meet the unique needs of remote
                                            workforces and their dynamic environments.
                                          </p>
                                        </a>
                                        <a className="site-nav-item" href="/global-employee-engagement/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1699339980/VantageFit/2023/global_employee_engagement.svg"
                                            alt="Global
                                                                                    Employee
                                                                                    Engagement"
                                          />
                                          <div className="nav-item-heading">Global Employee Engagement</div>
                                          <p className="nav-item-desc">
                                            Implement initiatives that cater to diverse cultural and regional
                                            preferences, fostering a connected global workforce.
                                          </p>
                                        </a>
                                        <a className="site-nav-item" href="/mental-health-and-wellbeing-challenges/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1699340013/VantageFit/2023/mental_health_and_wellbeing.svg"
                                            alt="Mental
                                                                                    Health
                                                                                    &
                                                                                    Well-being"
                                          />
                                          <div className="nav-item-heading">Mental Health & Well-being</div>
                                          <p className="nav-item-desc mb-0">
                                            Support a work environment that prioritizes mental health with targeted
                                            resources and supportive initiatives.
                                          </p>
                                        </a>
                                      </div>
                                      <div className="col-6 pr-0">
                                        <a className="site-nav-item" href="/holistic-wellness-program/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1699360829/VantageFit/2023/Holistic.svg"
                                            alt="Holistic
                                                                                    Wellness
                                                                                    Program"
                                          />
                                          <div className="nav-item-heading">Holistic Wellness Program</div>
                                          <p className="nav-item-desc">
                                            Embrace a well-rounded approach to well-being, encompassing multiple
                                            dimensions of a healthy corporate lifestyle.
                                          </p>
                                        </a>
                                        <a className="site-nav-item" href="/wellness-rewards-program/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1699360831/VantageFit/2023/wellness_rewards.svg"
                                            alt="Wellness
                                                                                    Rewards
                                                                                    Program"
                                          />
                                          <div className="nav-item-heading">Wellness Rewards Program</div>
                                          <p className="nav-item-desc">
                                            Drive positive health behaviors with a rewards system that celebrates
                                            wellness milestones and achievements.
                                          </p>
                                        </a>
                                        <a className="site-nav-item" href="/health-fitness-analytics/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1699360829/VantageFit/2023/Health_analytics.svg"
                                            alt="Health
                                                                                    &
                                                                                    Fitness
                                                                                    Analytics"
                                          />
                                          <div className="nav-item-heading">Health & Fitness Analytics</div>
                                          <p className="nav-item-desc mb-0">
                                            Utilize analytical insights to track and optimize the corporate wellness
                                            programs and encourage widespread participation.
                                          </p>
                                        </a>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                              <li className="listingMenu menu-soln feature-menu__item">
                                <a className="site-nav-item " onClick={(e) => e.preventDefault()}>
                                  Features
                                </a>
                                <ul className="dropdownmenu  row feat" style={{ top: '45px' }}>
                                  <li className="col-4 challenges-menu feat-left-menu">
                                    <div className="dropdown-menu-header">Holistic Wellness Trackers</div>
                                    <a className="site-nav-item" href="/features/activity-tracking/">
                                      <div className="d-flex align-items-start justify-content-md-start">
                                        <img
                                          className="mb-2 mr-3"
                                          src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/activity_tracking.svg"
                                          alt="Activity Tracking"
                                        />
                                        <div className="nav-item-heading">
                                          <span className="text-red">Activity Tracking</span>
                                          <p className="nav-item-desc mb-0">Capture every move, note progress.</p>
                                        </div>
                                      </div>
                                    </a>
                                    <a className="site-nav-item" href="/features/nutrition-and-hydration/">
                                      <div className="d-flex align-items-start justify-content-md-start">
                                        <img
                                          className="mb-2 mr-3"
                                          src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412165/VantageFit/2023/Nutrition_and_Hydration.svg"
                                          alt="Nutrition & Hydration"
                                        />
                                        <div className="nav-item-heading">
                                          <span className="text-red">Nutrition & Hydration</span>
                                          <p className="nav-item-desc mb-0">Fuel, hydrate, repeat.</p>
                                        </div>
                                      </div>
                                    </a>
                                    <a className="site-nav-item" href="/features/fitness-and-exercise/">
                                      <div className="d-flex align-items-start justify-content-md-start">
                                        <img
                                          className="mb-2 mr-3"
                                          src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Fitness_and_Exercise.svg"
                                          alt="Fitness & Exercise"
                                        />
                                        <div className="nav-item-heading">
                                          <span className="text-red">Fitness & Exercise</span>
                                          <p className="nav-item-desc mb-0">
                                            Your fitness journey, now at your fingertips.
                                          </p>
                                        </div>
                                      </div>
                                    </a>
                                    <a className="site-nav-item" href="/features/health-metrics/">
                                      <div className="d-flex align-items-start justify-content-md-start">
                                        <img
                                          className="mb-2 mr-3"
                                          src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Health_metrics.svg"
                                          alt="Health Metrics"
                                        />
                                        <div className="nav-item-heading">
                                          <span className="text-red">Health Metrics</span>
                                          <p className="nav-item-desc mb-0">Shape wellness with insightful metrics.</p>
                                        </div>
                                      </div>
                                    </a>
                                    <a className="site-nav-item" href="/features/mental-health-and-mindfulness/">
                                      <div className="d-flex align-items-start justify-content-md-start">
                                        <img
                                          className="mb-2 mr-3"
                                          src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412165/VantageFit/2023/mental_wellbeing.svg"
                                          alt="Mental Well-being"
                                        />
                                        <div className="nav-item-heading">
                                          <span className="text-red">Mental Well-being</span>
                                          <p className="nav-item-desc mb-0">Achieve balance, discover your zen.</p>
                                        </div>
                                      </div>
                                    </a>
                                  </li>
                                  <li className="col-8 other-soln-menu">
                                    <div className="dropdown-menu-header">Other Features</div>
                                    <div className="row">
                                      <div className="col-6 pl-0">
                                        <a className="site-nav-item d-flex" href="/features/accessibility/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Accessibility.svg"
                                            alt="Accessibility"
                                          />
                                          <div className="ml-4">
                                            <div className="nav-item-heading">Accessibility</div>
                                            <p className="nav-item-desc">
                                              Enable seamless well-being journeys across various devices, languages, and
                                              locations
                                            </p>
                                          </div>
                                        </a>
                                        <a className="site-nav-item d-flex" href="/features/admin-dashboard/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Admin_Dashboard.svg"
                                            alt="Admin Dashboard"
                                          />
                                          <div className="ml-4">
                                            <div className="nav-item-heading">Admin Dashboard</div>
                                            <p className="nav-item-desc">
                                              Equip wellness coordinators with robust tools for efficient program
                                              administration.
                                            </p>
                                          </div>
                                        </a>
                                        <a className="site-nav-item d-flex" href="/features/engagement-tools/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412163/VantageFit/2023/Engagement_Tools.svg"
                                            alt="Engagement Tools"
                                          />
                                          <div className="ml-4">
                                            <div className="nav-item-heading">Engagement Tools</div>
                                            <p className="nav-item-desc mb-0">
                                              Cultivate an active community, organize challenges, and commemorate
                                              accomplishments.
                                            </p>
                                          </div>
                                        </a>
                                        <a
                                          className="site-nav-item d-flex"
                                          href="/features/incentivization-and-rewards/"
                                        >
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412164/VantageFit/2023/Incentivization_Rewards.svg"
                                            alt="Incentivization & Rewards"
                                          />
                                          <div className="ml-4">
                                            <div className="nav-item-heading">Incentivization & Rewards</div>
                                            <p className="nav-item-desc">
                                              Inspiring healthy behaviors with our innovative system of incentives and
                                              rewards.
                                            </p>
                                          </div>
                                        </a>
                                      </div>
                                      <div className="col-6 pr-0">
                                        <a className="site-nav-item d-flex" href="/features/integrations/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412164/VantageFit/2023/Integration.svg"
                                            alt="Integration"
                                          />
                                          <div className="ml-4">
                                            <div className="nav-item-heading">Integrations</div>
                                            <p className="nav-item-desc">
                                              Simplify connecting devices, apps, and HR systems for a unified wellness
                                              journey.
                                            </p>
                                          </div>
                                        </a>
                                        <a className="site-nav-item d-flex" href="/features/security-and-compliance/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412165/VantageFit/2023/Security_Compliance.svg"
                                            alt="Security & Compliance"
                                          />
                                          <div className="ml-4">
                                            <div className="nav-item-heading">Security & Compliance</div>
                                            <p className="nav-item-desc mb-0">
                                              Prioritizing the protection of employee data.
                                            </p>
                                          </div>
                                        </a>
                                        <a className="site-nav-item d-flex" href="/features/wellness-leagues/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1738059656/VantageFit/2025/wellness_league.svg"
                                            alt="Security & Compliance"
                                          />
                                          <div className="ml-4">
                                            <div className="nav-item-heading">Wellness Leagues</div>
                                            <p className="nav-item-desc mb-0">
                                              Segment employees by step data into Bronze, Silver, or Gold Wellness
                                              Leagues.
                                            </p>
                                          </div>
                                        </a>
                                        <a className="site-nav-item d-flex" href="/features/personalized-programs/">
                                          <img
                                            className="mb-2"
                                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1747050611/VantageFit/2025/Personalised_Programs_icon.svg"
                                            alt="Security & Compliance"
                                            width={30}
                                            height={33}
                                          />

                                          <div className="ml-4">
                                            <div className="nav-item-heading">Personalized Program</div>
                                            <p className="nav-item-desc mb-0">
                                              Provide AI-powered wellness solutions designed to fit each employee's
                                              unique needs.
                                            </p>
                                          </div>
                                        </a>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a className="site-nav-item" href="/pricing/">
                                  {t(`Pricing`)}
                                </a>
                              </li>
                              <li className="listingMenu resource-menu__item">
                                <a className="site-nav-item" onClick={(e) => e.preventDefault()}>
                                  Resources
                                </a>
                                <ul className="dropdownmenu resources-menu">
                                  <li>
                                    <a aria-current="page" className="site-nav-item " href="/en/blog/">
                                      <div className="nav-item-heading">Blog</div>
                                      <p className="nav-item-desc">
                                        Discover valuable insights to enrich your corporate wellness program and stay
                                        current with wellness trends.
                                      </p>
                                    </a>
                                  </li>
                                  <li>
                                    <a aria-current="page" className="site-nav-item " href="/casestudy/">
                                      <div className="nav-item-heading">Client Success Stories</div>
                                      <p className="nav-item-desc">
                                        Discover how Vantage Fit empowers organizations globally to accomplish their
                                        employee wellness objectives.
                                      </p>
                                    </a>
                                  </li>
                                  <li>
                                    <a aria-current="page" className="site-nav-item " href="/guides/">
                                      <div className="nav-item-heading">Guides</div>
                                      <p className="nav-item-desc">
                                        Tailored resources for successful wellness program implementation, providing
                                        step-by-step guidance.
                                      </p>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      aria-current="page"
                                      className="site-nav-item "
                                      href="/en/blog/podcasts/"
                                      rel="noopener noreferer"
                                    >
                                      <div className="nav-item-heading">Podcasts</div>
                                      <p className="nav-item-desc">
                                        Stay informed with engaging wellness insights and best practices designed to
                                        empower your employees.
                                      </p>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      aria-current="page"
                                      className="site-nav-item "
                                      href="https://help.vantagefit.io/"
                                      target="_blank"
                                    >
                                      <div className="nav-item-heading">Help Center</div>
                                      <p className="nav-item-desc">
                                        Get answers to your questions and learn more about Vantage Fit.
                                      </p>
                                    </a>
                                  </li>
                                  {/* <li>
                                                                    <a
                                                                        aria-current="page"
                                                                        className="site-nav-item "
                                                                        href="/faq/"
                                                                    >
                                                                        <div className="nav-item-heading">
                                                                            FAQ
                                                                        </div>
                                                                        <p className="nav-item-desc">
                                                                            Get
                                                                            access
                                                                            to
                                                                            quick
                                                                            answers
                                                                            to
                                                                            effectively
                                                                            address
                                                                            common
                                                                            wellness
                                                                            program
                                                                            questions
                                                                            and
                                                                            inquiries.
                                                                        </p>
                                                                    </a>
                                                                </li> */}
                                </ul>
                              </li>

                              {/* <li>
                                                            <a
                                                                className="site-nav-item"
                                                                href="/contact-us/"
                                                            >
                                                                Contact Us
                                                            </a>
                                                        </li> */}
                            </ul>
                          </div>
                        </div>
                        <a
                          id="demo_btn_nav"
                          className="menu_cus btn_get btn-meta btn_hover menu-top mr-2 arrowbtn-img"
                          href="/request-demo/"
                        >
                          Book a Demo
                        </a>
                        <div className="languageSelect">
                          <button onClick={() => showDropdown()}>
                            <span className="pr-1">
                              <svg className="text-gray-400" viewBox="0 0 24 24" fill="#333" stroke="#333">
                                <path d="M12.02 0c6.614.011 11.98 5.383 11.98 12 0 6.623-5.376 12-12 12-6.623 0-12-5.377-12-12 0-6.617 5.367-11.989 11.981-12h.039zm3.694 16h-7.427c.639 4.266 2.242 7 3.713 7 1.472 0 3.075-2.734 3.714-7m6.535 0h-5.523c-.426 2.985-1.321 5.402-2.485 6.771 3.669-.76 6.671-3.35 8.008-6.771m-14.974 0h-5.524c1.338 3.421 4.34 6.011 8.009 6.771-1.164-1.369-2.059-3.786-2.485-6.771m-.123-7h-5.736c-.331 1.166-.741 3.389 0 6h5.736c-.188-1.814-.215-3.925 0-6m8.691 0h-7.685c-.195 1.8-.225 3.927 0 6h7.685c.196-1.811.224-3.93 0-6m6.742 0h-5.736c.062.592.308 3.019 0 6h5.736c.741-2.612.331-4.835 0-6m-12.825-7.771c-3.669.76-6.671 3.35-8.009 6.771h5.524c.426-2.985 1.321-5.403 2.485-6.771m5.954 6.771c-.639-4.266-2.242-7-3.714-7-1.471 0-3.074 2.734-3.713 7h7.427zm-1.473-6.771c1.164 1.368 2.059 3.786 2.485 6.771h5.523c-1.337-3.421-4.339-6.011-8.008-6.771"></path>
                              </svg>
                            </span>
                            {langSelected}
                          </button>
                          <ul className="languages">
                            {languages.map((lang) => (
                              <li
                                onClick={() => selectLangList(lang)}
                                key={lang}
                                style={{
                                  display: cssDisplay,
                                }}
                              >
                                <Link to={lang == `en-US` ? `/` : `/` + lang + `/`} language={lang}>
                                  {lang}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      <Navbar className="navbar-light mobile_navbar mainsite">
                        <NavbarBrand href="/" className="mr-auto">
                          <img
                            width="150"
                            height="45"
                            alt="Vantage Fit"
                            className="stick_logo"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                            data-loaded="true"
                          />
                          {/* <img
                            width="150"
                            height="45"
                            alt="Vantage Fit"
                            className="stick_logo"
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1734933277/VantageFit/2024/Asset_1.png"
                            data-loaded="true"
                          /> */}
                        </NavbarBrand>
                        <div className="languageSelect">
                          <button onClick={() => showDropdown()}>
                            <span className="pr-1">
                              <svg className="text-gray-400" viewBox="0 0 24 24" fill="#333" stroke="#333">
                                <path d="M12.02 0c6.614.011 11.98 5.383 11.98 12 0 6.623-5.376 12-12 12-6.623 0-12-5.377-12-12 0-6.617 5.367-11.989 11.981-12h.039zm3.694 16h-7.427c.639 4.266 2.242 7 3.713 7 1.472 0 3.075-2.734 3.714-7m6.535 0h-5.523c-.426 2.985-1.321 5.402-2.485 6.771 3.669-.76 6.671-3.35 8.008-6.771m-14.974 0h-5.524c1.338 3.421 4.34 6.011 8.009 6.771-1.164-1.369-2.059-3.786-2.485-6.771m-.123-7h-5.736c-.331 1.166-.741 3.389 0 6h5.736c-.188-1.814-.215-3.925 0-6m8.691 0h-7.685c-.195 1.8-.225 3.927 0 6h7.685c.196-1.811.224-3.93 0-6m6.742 0h-5.736c.062.592.308 3.019 0 6h5.736c.741-2.612.331-4.835 0-6m-12.825-7.771c-3.669.76-6.671 3.35-8.009 6.771h5.524c.426-2.985 1.321-5.403 2.485-6.771m5.954 6.771c-.639-4.266-2.242-7-3.714-7-1.471 0-3.074 2.734-3.713 7h7.427zm-1.473-6.771c1.164 1.368 2.059 3.786 2.485 6.771h5.523c-1.337-3.421-4.339-6.011-8.008-6.771"></path>
                              </svg>
                            </span>
                            {langSelected}
                          </button>
                          <ul className="languages">
                            {languages.map((lang) => (
                              <li
                                onClick={() => selectLangList(lang)}
                                key={lang}
                                style={{
                                  display: cssDisplay,
                                }}
                              >
                                <Link to={lang == `en-US` ? `/` : `/` + lang + `/`} language={lang}>
                                  {lang}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                        <Collapse isOpen={!collapsed} navbar>
                          <ul className="mobileheader_menu">
                            <li className="mobile_listing ">
                              Solutions
                              <ul className="dropdownmenu">
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/steps-challenge/">
                                    Steps Challenge
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/multi-activity-challenges/">
                                    Custom Challenges
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/team-challenges/">
                                    Team Challenge
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/virtual-marathon/">
                                    One Day Virtual Marathon
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/remote-team-wellness/">
                                    Remote Team Wellness
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/global-employee-engagement/">
                                    Global Employee Engagement
                                  </a>
                                </li>
                                <li>
                                  <a
                                    aria-current="page"
                                    className="site-nav-item"
                                    href="/mental-health-and-wellbeing-challenges/"
                                  >
                                    Mental Health and Wellbeing Challenges
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/holistic-wellness-program/">
                                    Holistic Wellness Program
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/wellness-rewards-program/">
                                    Wellness Rewards Program
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/health-fitness-analytics/">
                                    Health and Fitness Analytics
                                  </a>
                                </li>
                              </ul>
                            </li>
                            <li className="mobile_listing ">
                              Features
                              <ul className="dropdownmenu">
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/features/activity-tracking/">
                                    Activity Tracking
                                  </a>
                                </li>
                                <li>
                                  <a
                                    aria-current="page"
                                    className="site-nav-item"
                                    href="/features/nutrition-and-hydration/"
                                  >
                                    Nutrition & Hydration
                                  </a>
                                </li>
                                <li>
                                  <a
                                    aria-current="page"
                                    className="site-nav-item"
                                    href="/features/fitness-and-exercise/"
                                  >
                                    Fitness & Exercise
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/features/health-metrics/">
                                    Health Metrics
                                  </a>
                                </li>
                                <li>
                                  <a
                                    aria-current="page"
                                    className="site-nav-item"
                                    href="/features/mental-health-and-mindfulness/"
                                  >
                                    Mental Well-being
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/features/accessibility/">
                                    Accessibility
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/features/admin-dashboard/">
                                    Admin Dashboard
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/features/engagement-tools/">
                                    Engagement Tools
                                  </a>
                                </li>
                                <li>
                                  <a
                                    aria-current="page"
                                    className="site-nav-item"
                                    href="/features/incentivization-and-rewards/"
                                  >
                                    Incentivization & Rewards
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/features/integrations/">
                                    Integrations
                                  </a>
                                </li>
                                <li>
                                  <a
                                    aria-current="page"
                                    className="site-nav-item"
                                    href="/features/security-and-compliance/"
                                  >
                                    Security & Compliance
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item" href="/features/wellness-leagues/">
                                    Wellness Leagues
                                  </a>
                                </li>
                                <li>
                                  <a
                                    aria-current="page"
                                    className="site-nav-item"
                                    href="/features/personalized-programs/"
                                  >
                                    Personalized Program
                                  </a>
                                </li>
                              </ul>
                            </li>
                            <li>
                              <a className="site-nav-item" href="/pricing/">
                                {t(`Pricing`)}
                              </a>
                            </li>
                            <li className="mobile_listing">
                              Resources
                              <ul className="dropdownmenu">
                                <li>
                                  <a aria-current="page" className="site-nav-item " href="/en/blog/">
                                    Blog
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item " href="/casestudy/">
                                    Client Success Stories
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item " href="/guides/">
                                    Guides
                                  </a>
                                </li>
                                <li>
                                  <a aria-current="page" className="site-nav-item " href="/en/blog/podcasts/">
                                    Podcasts
                                  </a>
                                </li>
                                <li>
                                  <a
                                    aria-current="page"
                                    className="site-nav-item "
                                    href="https://help.vantagefit.io/"
                                    target="_blank"
                                  >
                                    Help Centers
                                  </a>
                                </li>
                              </ul>
                            </li>
                            {/* <li>
                                                        <a
                                                            className="site-nav-item"
                                                            href="/contact-us/"
                                                        >
                                                            Contact Us
                                                        </a>
                                                    </li> */}
                            <li>
                              <a
                                className="menu_cus btn_get btn-meta btn_hover menu-top arrowbtn-img"
                                href="/request-demo/"
                              >
                                Book a Demo
                              </a>
                            </li>
                          </ul>
                        </Collapse>
                      </Navbar>
                    </div>
                  </nav>
                </header>
              </div>
            )
          ) : null}
          {/* New Nav Starts  */}
          {path === `/healthy-new-year` || path === `/healthy-new-year/` ? (
            <div className="headerWrapper">
              {/* { removeHellobarUrl.includes(path) ? null : helloBarMessage === true ? (<Hellobar hellobarTextForUrl={hellobarTextForUrl} />) : null } */}
              <header
                className={`header_area header_stick nav-black brad48 ${scroll1 ? (displayHelloBar ? `` : ``) : null}`}
                id="headerarea"
              >
                <HelloBar scroll1={scroll1} />
                <nav className="navbar navbar-expand-lg menu_center mainsite1 py-2">
                  <div className="container custom_container">
                    <div className="site-mast-left">
                      <Link to="/" className="navbar-brand sticky_logo">
                        <img
                          width="220"
                          height="45"
                          className="d_logo site-logo"
                          src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                          alt={site.title}
                        />
                      </Link>
                    </div>
                    <div className="collapse navbar-collapse justify-content-center vfit-main">
                      <div id="menu-main-menu-global" className="navbar-nav menu  ml-auto">
                        <div className="nav-home menu-item nav-item HeaderN" role="menuitem"></div>
                      </div>
                      <a className="menu_cus btn_get btn-meta btn_hover menu-top arrowbtn-img mr-2" href="#form">
                        Talk to our experts
                      </a>
                    </div>

                    <Navbar className="navbar-light mobile_navbar mainsite">
                      <NavbarBrand href="/" className="mr-auto">
                        <img
                          width="220"
                          height="45"
                          alt="Vantage Fit"
                          className="stick_logo"
                          src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                          data-loaded="true"
                        />
                      </NavbarBrand>
                      <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                      <Collapse isOpen={!collapsed} navbar>
                        <ul className="mobileheader_menu">
                          <li>
                            <a className="menu_cus btn_get btn-meta btn_hover menu-top arrowbtn-img mr-2" href="#form">
                              Talk to our Wellness Experts{` `}
                            </a>
                          </li>
                        </ul>
                      </Collapse>
                    </Navbar>
                  </div>
                </nav>
              </header>
            </div>
          ) : null}
          {/* New Nav Ends */}

          {isHome ? (
            <div className="elementor">{children}</div>
          ) : (
            <main className="site-main">
              {/* All the main content gets inserted here, index.js, post.js */}
              {children}
            </main>
          )}
        </div>
        {/* {!nonFooterLinks.includes(path) &&
                path != ( "/fr/" || "/fr/planifier-demo/" || "/fr/wellness-challenges/" || "/fr/wellness-programs/" || "/fr/rewards-and-recognition/" || "/fr/wellbeing-community/") ? (
                    <Footer />
                ) : path ===( "/fr/" || "/fr/planifier-demo/" || "/fr/wellness-challenges/" || "/fr/wellness-programs/" || "/fr/rewards-and-recognition/" || "/fr/wellbeing-community/") ? (
                    <SimpleFooter />
                ) : null} */}

        {path.startsWith(`/articles/`) ? null : path === // Remove footer for paths that start with /articles/
            `/employee-wellness` ||
          path === `/employee-wellness/` ||
          path === `/employee-wellness-v1` ||
          path === `/employee-wellness-v1/` ||
          path === `/global-employee-wellness-platform` ||
          path === `/global-employee-wellness-platform/` ||
          path === `/employee-wellness-pmp` ||
          path === `/employee-wellness-pmp/` ||
          path === `/vantagefit-wellness-campaigns/` ? (
          <Slice alias="SimpleFooter" />
        ) : (
          <Slice alias="footerMain" />
        )}
      </div>
    </>
  )
}

DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired,
  bodyclassName: PropTypes.string,
  isHome: PropTypes.bool,
  data: PropTypes.shape({
    file: PropTypes.object,
    allGhostSettings: PropTypes.object.isRequired,
  }).isRequired,
}

const DefaultLayoutSettingsQuery = (props) => (
  <StaticQuery
    query={graphql`
      query GhostSettings {
        allGhostSettings {
          edges {
            node {
              ...GhostSettingsFields
            }
          }
        }
      }
    `}
    render={(data) => <DefaultLayout data={data} {...props} />}
  />
)

export default DefaultLayoutSettingsQuery
